export const eventOccasionOptions: string[] = [
    "Sie haben geheiratet",
    "Sie haben sich scheiden lassen",
    "Sie haben Nachwuchs bekommen",
    "Sie sind umgezogen",
    "Sie verreisen",
    "Sie erwerben eine Immobilie",
    "Sie möchten Ihr Kraftfahrzeug absichern",
    "Sie wünschen die Anpassung Ihres Versicherungsvertrages",
    "Sie haben eine Ausbildung begonnen",
    "Sie haben Ihre Einnahmensituation verbessert",
    "Sie haben geerbt",
    "Sie haben Kinder bzw. Enkelkinder bekommen",
    "Sie starten ins Berufsleben",
    "Sie planen Ihren Ruhestand",
    "Sie wollen Ihre Vorsorge- und Finanzsituation überprüfen",
];
